

import YandexCaptcha from "modules/auth/components/yandex-captcha.vue";
import YiiCaptcha from "modules/auth/components/yii-captcha.vue";
import { PropType } from "vue";
import { v4 as uuid } from "uuid";

export default {
    components: { YiiCaptcha, YandexCaptcha },
    props: {
        configuration: Object as PropType<object>,
        onNext: Function as PropType<() => void>,
        modelValue: String,
        error: String,
        value: String,
        typeValue: String,
    },
    expose: ["refresh", "execution"],
    methods: {
        async execution(): Promise<any> {
            if (this.showCaptcha('yandex')) {
                await this.$refs.yandex.execution();
                return;
            }

            // this.refresh();
        },
        async refresh() {
            if (this.showCaptcha('yandex')) {
                await this.$refs.yandex.reset();
                return;
            }

            this.captchaId = uuid();
        },
        showCaptcha(name) {
            if (this.value && this.value.length > 14 && this.typeValue === "phone") {
                const config = this.configuration.captcha;
                if (config) {
                    return config["provider"] == name;
                }
            }
            return false;
        },
        onUpdate(value) {
            this.$emit("update:modelValue", value);
        },
    },
    data() {
        return {
            captchaId: uuid() + this.value,
        };
    },

};
